import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20soft%20dreamy%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20abstract%20flowing%20shapes%2C%20gentle%20gradient%20background%2C%20reading%20nook%20vibe%2C%20cozy%20ambient%2C%20ethereal%20glow%2C%20artistic%20painterly%20composition%2C%20peaceful%20mood%2C%20no%20text%2C%20clean%20aesthetic&width=1800&height=600&seq=cta-bg-2026&orientation=landscape"
            alt="开始阅读韩漫"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>

          <div className="relative z-10 py-14 md:py-20 px-6 md:px-10 text-center">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-white leading-tight max-w-2xl mx-auto">
              准备好开启你的
              <span className="italic font-normal text-white/90">韩漫之旅</span>
              了吗？
            </h2>
            <p className="mt-3 text-sm md:text-base text-white/60 max-w-lg mx-auto">
              数千部韩国漫画等你来探索，即刻开始免费阅读，享受下拉式阅读的极致体验
            </p>
            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link
                to="/category/romance"
                className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
              >
                立即开始阅读
                <i className="ri-arrow-right-line ml-1.5"></i>
              </Link>
              <Link
                to="/about"
                className="px-8 py-3.5 rounded-full text-sm md:text-base font-medium bg-white/15 backdrop-blur-sm text-white hover:bg-white/25 transition-colors duration-200 whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}